import React from 'react';

import {Avatar, type AvatarProps} from '@mui/material';
import {styled, type WithMuiPropOverrides} from '@netx/core-components/Theme';
import {
	GenericImage,
	type GenericImageProps,
	genericImageClasses,
} from '@netx/core-components/GenericImage';

const GenericImageAvatarRoot = styled(Avatar)(({theme}) => ({}));

const GenericImageAvatarImage = styled(GenericImage)(({theme}) => ({
	width: '100%',
	height: '100%',
	[`& .${genericImageClasses.image}`]: {
		objectFit: 'cover',
		maxHeight: '100%',
		maxWidth: '100%',
	},
}));

export interface GenericImageAvatar extends WithMuiPropOverrides<AvatarProps> {
	alt: string;
	src?: string;
	genericImageProps?: Omit<GenericImageProps, 'ref' | 'src' | 'alt'>;
}

export const GenericImageAvatarPrimitive = ({
	alt,
	genericImageProps,
	src,
	...props
}: GenericImageAvatar) => {
	return (
		<GenericImageAvatarRoot aria-label={alt} {...props}>
			<GenericImageAvatarImage
				disableFade
				{...genericImageProps}
				alt={alt}
				src={src}
			/>
		</GenericImageAvatarRoot>
	);
};

export const GenericImageAvatar = GenericImageAvatarPrimitive;

export default GenericImageAvatar;
